import './skeleton.css'

export const PowerPerformanceRiveSkeleton = () => {
  return null
  // return <div className='skeleton w-[104px] h-[104px] rounded-[50%]'></div>
}
